import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Shared premium button. variant: 'primary' | 'ghost-light' | 'ghost-dark'
export function CTA({ to = "/book", children, variant = "primary", arrow = true, testId, className = "", track, location }) {
  const base =
    "inline-flex items-center justify-center gap-3 font-body font-medium text-[15px] px-9 py-4 transition-all duration-300 group";
  const variants = {
    primary: "bg-[#D4AF37] text-black hover:bg-[#E6C75A] hover:-translate-y-0.5",
    "ghost-light":
      "bg-transparent text-white border border-white/35 hover:border-[#D4AF37] hover:text-[#D4AF37]",
    "ghost-dark":
      "bg-transparent text-black border border-black/20 hover:border-[#D4AF37] hover:text-[#D4AF37]",
  };
  const trackAttrs = track
    ? { "data-track": "cta_click", "data-track-label": track, "data-track-location": location || "" }
    : {};
  return (
    <Link to={to} data-testid={testId} {...trackAttrs} className={`${base} ${variants[variant]} ${className}`}>
      {children}
      {arrow && (
        <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </Link>
  );
}

// Section eyebrow label
export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`font-body text-xs tracking-[0.34em] uppercase text-[#D4AF37] ${className}`}>
      {children}
    </p>
  );
}

export default CTA;
